exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".log_lights{display:block;padding:15pt;background-color:#fff}.log_lights .ui.menu{font-size:.8rem}.log-lights .ui.basic.segment{background-color:#f2f2f2}", "", {"version":3,"sources":["/home/steven/dev/Sporte/sporte2/src/components/reports/LightsTable.vue"],"names":[],"mappings":"AACA,YACE,cAAe,AACf,aAAc,AACd,qBAAwB,CACzB,AACD,qBACE,eAAkB,CACnB,AACD,8BACE,wBAA0B,CAC3B","file":"LightsTable.vue","sourcesContent":["\n.log_lights {\n  display: block;\n  padding: 15pt;\n  background-color: white;\n}\n.log_lights .ui.menu {\n  font-size: 0.8rem;\n}\n.log-lights .ui.basic.segment {\n  background-color: #F2F2F2;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c66fac62","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reports/LightsTable.vue
// module id = 952
// module chunks = 26